module.exports = {
  version: 'Speech analytics U-Speech Analytics v.2.4',
  copyright: '© «UKITECH LAB» ',
  copyrightCallTraffic: '© «CallTraffic» ',
};
